export const formatUserInfo = (user: any) => {
  return `${user.first_name} ${user.last_name} (${
    user.username ? user.username : user.chat_id
  })`;
};